/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/31
 */
import url from 'url';

const extendSearch = (search, query) => {
  const parsed = url.parse(`/a${search}`, true);
  const newQuery = Object.assign(parsed.query, query);
  const format = url.format({
    pathname: '/a',
    query: newQuery
  });
  return {
    search: url.parse(format).search,
    query: newQuery
  };
};
  // url.parse(`${pathname}${search}`, true).query;


export default extendSearch;



// WEBPACK FOOTER //
// ./src/utils/extendSearch.js